import React from 'react';
import '../styles/Footer.css';
import githubIcon from '../assets/images/github.png'; // Adjust the path to your icons
import linkedinIcon from '../assets/images/linkedin.png';
import instagramIcon from '../assets/images/instagram.png';
import emailIcon from '../assets/images/gmail.png';
import phoneIcon from '../assets/images/phone.png';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-links">
                <a href="https://github.com/exploring-curiosity" target="_blank" rel="noopener noreferrer">
                    <img src={githubIcon} alt="GitHub" className="footer-icons" />
                    <span className='footer-text'>exploring-curiosity</span>
                </a>
                <a href="https://linkedin.com/in/sudharshanramesh" target="_blank" rel="noopener noreferrer">
                    <img src={linkedinIcon} alt="LinkedIn" className="footer-icons" />
                    <span className='footer-text'>sudharshanramesh</span>
                </a>
                <a href="https://instagram.com/_sudhan_r" target="_blank" rel="noopener noreferrer">
                    <img src={instagramIcon} alt="Instagram" className="footer-icons" />
                    <span className='footer-text'>_sudhan_r</span>
                </a>
                <a href="mailto:sr7431@nyu.edu">
                    <img src={emailIcon} alt="Email" className="footer-icons" />
                    <span className='footer-text'>sr7431@nyu.edu</span>
                </a>
                <a href="tel:+13472835115">
                    <img src={phoneIcon} alt="Phone" className="footer-icons" />
                    <span className='footer-text'>+1 (347)-283-5115</span>
                </a>
            </div>
        </footer>
    );
};

export default Footer;